import { Vector2 } from 'three';

/**
 * Indicates whether the query vector is facing left or right of the other input vector on a 2D plane.
 *
 * @param {Vector2} direction Vector separating the plane into two halfs
 * @param {Vector2} queryVector Query vector
 */
export const isVectorLeftOf = (direction: Vector2, queryVector: Vector2): boolean =>
  direction.x * queryVector.y - direction.y * queryVector.x > 0;
